<template>
    <v-dialog v-model="dialog" width="900px">
      <v-card>
        <p class=".title ma-2">Email sent to contacts</p>
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="(mail, i) in review_mail"
                  :key="i"
                  @click="$router.open('/mail/showMail/' + mail.mail_encrid)"
                >
                  <td>{{ mail.mail_dt }}</td>
                  <td>{{ mail.mail_oms }}</td>
                  <td>{{ mail.mail_to }}</td>
                  <td>
                    <v-chip :color="mail.mlrc_id" text-color="white">
                      <v-avatar left>
                        <v-icon v-if="mail.mlrc_id === 'success'"
                          >mdi-checkbox-marked-circle</v-icon>
                        <v-icon v-else
                          >mdi-close-circle</v-icon>  
                      </v-avatar>
                      {{ mail.mlrc_dt }}
                    </v-chip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" small @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  export default {
      data() { 
        return {
            dialog: false,
            review: {},
            review_mail: {},
        }
    },
    methods: {
      open(review) {
        this.review = review;
        this.$axios
            .post("ares/json/ares/task/customer_success/revw/getRevwEmails.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "getRevwEmails",
            },
            getRevwEmails: {
              encrid: this.review.encrid,
              table: this.review.table,
            },
          })
          .then((res) => {
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              this.review_mail = res.data.getRevwEmails.mail;
            }
          })
          .finally(() => {
            this.dialog = true;
            this.loading = false;
          });
      },
    },
  };
  </script>
  
  